export const yearOfStudies = [
  "4. třída ZŠ",
  "5. třída ZŠ",
  "6. třída ZŠ",
  "7. třída ZŠ",
  "8. třída ZŠ",
  "9. třída ZŠ",
  "1. ročník SŠ",
  "2. ročník SŠ",
  "3. ročník SŠ",
  "4. ročník SŠ",
  "Vysoká škola",
  "Jiná"
]

export const relationToStudent = ["matka", "otec", "opatrovník", "rodinný příslušník", "jiný"]

export const schoolRegions = [
  "Hlavní město Praha",
  "Jihočeský kraj",
  "Jihomoravský kraj",
  "Karlovarský kraj",
  "Kraj Vysočina",
  "Královéhradecký kraj",
  "Liberecký kraj",
  "Moravskoslezský kraj",
  "Olomoucký kraj",
  "Pardubický kraj",
  "Plzeňský kraj",
  "Středočeský kraj",
  "Ústecký kraj",
  "Zlínský kraj"
]

export const referralSources = [
  "Internetové vyhledávání",
  "Sociální média",
  "Doporučení od přátel",
  "E-mailové novinky",
  "Web nebo newsletter školy",
  "Reklama na internetu",
  "Jiné"
]
